<template>
  <div class="text-center">
    <v-btn class="mr-4" @click="$router.go(-1)" text>{{
      $t("button.back")
    }}</v-btn>
    <v-btn
      color="secondary"
      class="mr-4"
      @click="process()"
      v-if="item.state === 'VD' || item.state === 'PC'"
      :disabled="item.state === 'PC'"
      v-model="item"
      >
      <v-icon left>mdi-cogs</v-icon>
      {{ $t("button.process") }}
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    item: Object
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {},
    process() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/process/" +
        this.item.object_type +
        "/" +
        this.$route.params.id;
      let form_trname = `forms.titles.${this.item.form_name}`
      axios
        .patch(path)
        .then(response => {
          // Emit to parent so it updates the form state
          this.item.state = 'PC';
          this.item.object_id = response.data.object_id;
          this.$emit('item-processed', this.item);
          // Alert user
          this.$store.commit("alert", {
            color: "success",
            text: this.$t("forms.process", [this.$t(form_trname)])
          });
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("alert", {
            color: "error",
            text: error.response.data
          });
        });
    },

    finish() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/finish/" +
        this.item.object_type +
        "/" +
        this.$route.params.id;
      let form_trname = `forms.titles.${this.item.form_name}`
      axios
        .patch(path)
        .then(response => {
          this.$store.commit("alert", {
            color: "success",
            text: this.$t("forms.finish", [this.$t(form_trname)])
          });
          this.$router.push("/manage/forms");
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("alert", {
            color: "error",
            text: error.response.data
          });
        });
    }
  }
};
</script>
